module.exports = __webpack_public_path__ + "img/PT73.f54b1c00.png";